import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faChartPie, faArrowsSpin, faListCheck, 
    faCrown, faTicket, faUsersCog, 
    faBuilding,
    faTags,
    faCalendarCheck,
    faShoppingCart
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export default function AdminListItems({ onItemClick }) {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();

    const redireccionar = (ruta) => {
        history.push(ruta);
        if (onItemClick) onItemClick();
    };

    const MenuItemCustom = ({ route, icon, text }) => {
        const isActive = location.pathname.includes(route); 

        return (
            <ListItem disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                    onClick={() => redireccionar(route)}
                    sx={{
                        borderRadius: 3,
                        minHeight: 46,
                        backgroundColor: isActive ? '#e3f2fd' : 'transparent', // Azul claro de tu tema
                        color: isActive ? theme.palette.primary.main : '#555',
                        '&:hover': {
                            backgroundColor: isActive ? '#e3f2fd' : '#f5f5f5',
                        },
                    }}
                >
                    <ListItemIcon sx={{ minWidth: 40, color: isActive ? theme.palette.primary.main : '#888' }}>
                        <FontAwesomeIcon icon={icon} />
                    </ListItemIcon>
                    <ListItemText 
                        primary={text} 
                        primaryTypographyProps={{ 
                            fontWeight: isActive ? 700 : 500,
                            fontSize: '0.95rem'
                        }} 
                    />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <>
            <Box sx={{ mt: 2, mb: 1, ml: 1 }}>
                <Typography variant='caption' sx={{ color: '#aaa', fontWeight: 700, letterSpacing: 1, fontSize: '0.7rem' }}>
                    CORE
                </Typography>
            </Box>
            <MenuItemCustom route="/admin/dashboard" icon={faChartPie} text="Visión General" />
            <MenuItemCustom route="/admin/users" icon={faUsersCog} text="Usuarios App" />

            <Box sx={{ mt: 3, mb: 1, ml: 1 }}>
                <Typography variant='caption' sx={{ color: '#aaa', fontWeight: 700, letterSpacing: 1, fontSize: '0.7rem' }}>
                    FINANZAS & B2C
                </Typography>
            </Box>
            <MenuItemCustom route="/admin/billing" icon={faArrowsSpin} text="Suscripciones SaaS" />
            <MenuItemCustom route="/admin/plans" icon={faListCheck} text="Gestión de Planes" />
            <MenuItemCustom route="/admin/qud-pass" icon={faCrown} text="Usuarios QUD Pass" />

            <Box sx={{ mt: 3, mb: 1, ml: 1 }}>
                <Typography variant='caption' sx={{ color: '#aaa', fontWeight: 700, letterSpacing: 1, fontSize: '0.7rem' }}>
                    OPERACIONES
                </Typography>
            </Box>
            <MenuItemCustom route="/products" icon={faTags} text={t('merchantPanel.menuOptions.products')} />
            <MenuItemCustom route="/assets" icon={faBuilding} text={t('merchantPanel.menuOptions.assets')} />
            <MenuItemCustom route="/merchant/loyalty" icon={faCalendarCheck} text={t('merchantPanel.menuOptions.bookings')} />
            <MenuItemCustom route="/orders" icon={faShoppingCart} text={t('merchantPanel.menuOptions.orders')} />
            <MenuItemCustom route="/subscriptions" icon={faArrowsSpin} text={t('merchantPanel.menuOptions.subscriptions')} />
            <MenuItemCustom route="/reservations" icon={faCalendarCheck} text={t('merchantPanel.menuOptions.bookings')} />
            <MenuItemCustom route="/events" icon={faTicket} text="Eventos & Tickets" />
        </>
    );    
}